import { render, staticRenderFns } from "./MerchantNewsManage.vue?vue&type=template&id=27a8d829&scoped=true"
import script from "./MerchantNewsManage.vue?vue&type=script&lang=js"
export * from "./MerchantNewsManage.vue?vue&type=script&lang=js"
import style0 from "./MerchantNewsManage.vue?vue&type=style&index=0&id=27a8d829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8d829",
  null
  
)

export default component.exports